export default function ErrorMessage(props: { text: any; center?: boolean }) {
	const { text = "", center = false } = props;
	if (text)
		return (
			<span className={`text-red-600 block ${center && "text-center"}`}>
				{text}
			</span>
		);
	return null;
}
